import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CheckOutDetails, CheckOutModel, CheckOutResult } from './CheckOut.models';

@Injectable({
  providedIn: 'root'
})
export class CheckOutService {
  refreshView = new BehaviorSubject<any>(false);
  refreshPrices = new BehaviorSubject<boolean>(false);
  checkOutDone = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  ResGetDiscountList(orderId: number) {
    return this.http.get(`${environment.apiUrl}/ResCheckOut/ResGetDiscountList?OrderId=${orderId}`);
  }
  ResGetOrderPaymentById(orderId: number) {
    return this.http.get<CheckOutDetails>(`${environment.apiUrl}/ResCheckOut/ResGetOrderPaymentById?OrderId=${orderId}`);
  }
  ResApplyOrderDiscount(data: any) {
    return this.http.post(`${environment.apiUrl}/ResCheckOut/ResApplyOrderDiscount`, data);
  }
  ResApplyItemDiscount(data: any) {
    return this.http.post(`${environment.apiUrl}/ReservationOrder/ResApplyItemDiscount`, data);
  }
  ResApplyTotalDiscount(OrderId: number) {
    return this.http.get(`${environment.apiUrl}/ResCheckOut/ResApplyTotalDiscount?OrderId=${OrderId}`);
  }
  ResCloseOrder(OrderId: number) {
    return this.http.get(`${environment.apiUrl}/ResCheckOut/ResCloseOrder?OrderId=${OrderId}`);
  }
  ResApplySurcharge(data: any) {
    return this.http.post(`${environment.apiUrl}/ResCheckOut/ResApplySurcharge`, data);
  }
  ResRemoveOrderDiscount(orderId: number) {
    return this.http.get(`${environment.apiUrl}/ResCheckOut/ResRemoveOrderDiscount?OrderId=${orderId}`);
  }
  ResRemoveOrderSurcharge(orderId: number) {
    return this.http.get(`${environment.apiUrl}/ResCheckOut/ResRemoveOrderSurcharge?OrderId=${orderId}`);
  }
  ResGetTotalPrice(data: any) {
    return this.http.post(`${environment.apiUrl}/ReservationOrder/ResGetTotalPrice`, data);
  }
  ResCheckOut(data: CheckOutModel) {
    return this.http.post<CheckOutResult>(`${environment.apiUrl}/ResCheckOut/ResCheckOut`, data);
  }
  ResAddTip(data: any) {
    return this.http.post(`${environment.apiUrl}/ResCheckOut/ResAddTip`, data);
  }
  ResCheckOutSplitItemsDetails(data: any) {
    return this.http.post(`${environment.apiUrl}/ResCheckOut/ResCheckOutSplitItemsDetails`, data);
  }
  ResCheckOutSplitPriceDetails(data: any) {
    return this.http.post(`${environment.apiUrl}/ResCheckOut/ResCheckOutSplitPriceDetails`, data);
  }
  ResGetCheckOutRecipt(OrderId: number, CheckOutId: number) {
    let query = `OrderId=${OrderId}`;
    // if (CheckOutId) { query += `&CheckOutId=${CheckOutId}`; }
    return this.http.get(`${environment.apiUrl}/ResCheckOut/ResGetCheckOutRecipt?${query}`);
  }
  prentrest(data: any) {
    let query = `OrderId=${data.OrderId}&deviceId=${data.deviceId}&deviceType=${data.deviceType}`;
    if (data.CheckOutId) { query += `&CheckOutId=${data.CheckOutId}`; }
    return this.http.get(`${environment.apiUrl}/ResCheckOut/prentrest?${query}`);
  }
  ResPrentOrderPriceList(orderId: number) {
    let params: any = { orderId }
    if (localStorage.getItem('deviceId')) {
      params.deviceId = localStorage.getItem('deviceId');
    }
    return this.http.get(`${environment.apiUrl}/ResCheckOut/ResPrentOrderPriceList`, { params });
  }
  ResGetCheckoutId(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/ResCheckOut/ResGetCheckoutId`, data);
  }
  ResGetNFCSDK(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/ResCheckOut/ResGetNFCSDK`, data);
  }
  ResGetCheckoutStatus(CheckoutId: any) {
    return this.http.get<CheckOutResult>(`${environment.apiUrl}/ResCheckOut/ResGetCheckoutStatus?CheckoutId=${CheckoutId}`);
  }
}
